import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import MiniApp from './components/MiniApp';
import BookingForm from './components/BookingForm';
import CategoryVideoList from './components/CategoryVideoList';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MiniApp />} />
          <Route path="/booking-form" element={<BookingForm />} />
          <Route path="/category/:categoryId" element={<CategoryVideoList />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
